
const names:any = {
    themeId: "شناسه تم",
    themName: "نام تم",
    siteName: "نام سایت",
    address: "آدرس",
    phone: "شماره ثابت",
    mobile: "شماره موبایل",
    email: "ایمیل",
    socials: "شبکه های مجازی",
    emailForm: "فرم ایمیل",
    1: "جایگاه اول",
    2: "جایگاه دوم",
    3: "جایگاه سوم",
    4: "جایگاه چهارم",
    5: "جایگاه پنجم",
    charts: "چارت ها",
    timelines: "تایم لاین",
    service: "خدمات",
    category: "دسته بندی",
    categories: "دسته بندی ها",
    portfo: "نمونه کار",
    comment: "کامنت",
    post: "پست",
    map: "نقشه",
    contactForm: "فرم تماس",
    social: "شبکه ها",
    name: "نام آیتم",
    visible: "فعال سازی",
    year: "سال",
    header: "موضوع",
    caption: "توضیحات آیتم",
    body: "متن",
    icon: "آیکون",
    title: "عنوان",
    description: "توضیحات",
    menuItem: "آیتم های منو",
    backImage: "تصویر پس زمینه",
    image: "تصویر",
    resume: "فایل رزومه CV",
    breif: "توضیحات مختصر",
    chart: "المان ها",
    timeline: "المان ها",
    stat: "آمار",
    person: "نام شخص",
    career: "سمت",
    logoList: 'لیست لوگوها',
    date: "تاریخ",
    lat: "عرض جغرافیایی",
    lng: "طول جغرافیایی",
    logo: "لوگو",
    featured: "تصویر شاخص",
    blog: "بخش وبلاگ",
    products: "بخش محصولات",
    message: "بخش پیام های کاربران",
    subtitle: "توضیح کوتاه",
    note: "توضیح",
    id: "شناسه آیتم",
    price: "قیمت",
    excerpt: "توضیحات مختصر",
    offPercent: "درصد تخفیف",
    offDate: "زمان حراجی",
    establish: "تاریخ تاسیس",
    video: "لینک ویدیو",
    line1: "متن اول",
    line2: "متن دوم",
    banner: "بنر پشتی",
    instagram: "اینستاگرام",
    twitter: "توییتر",
    facebook: "فیسبوک",
    linkedin: "لینکدین",
    time: "ساعات کاری",
    bio: "بیوگرافی",
    slides: "اسلاید ها",
    count: "تعداد",
    features: "ویژگی ها",
    link: "لینک به صفحه",
    team: "اعضا",
    profile: "عکس پروفایل",
    comments: "نظرات",
    button1: "کلید ۱",
    button2: "کلید ۲",
    "product/prod-category": "ویرایش دسته ها",
    salebanner1: "بنر تخفیف ۱",
    salebanner2: "بنر تخفیف ۲",
    banners: "بنرهای سایت",
    items:"موارد",
    tags:"تگ ها",
    product:"ویرایش محصولات",
}

export const formNames = (name:string) => {
    return names[name]
}